var exports = {
  "zr": "root__eEFxg6",
  "SU": "muted__7_C2D3",
  "kX": "success__E654O_",
  "lK": "unlimitedIcon__jAiYK2",
  "he": "refreshIcon__C_yN2S",
  "Qq": "text__6nnDiO",
  "V6": "planName__30ws1S",
  "Qs": "content__iWV8By",
};

module.exports = exports;
